import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { TranslateService } from '@ngx-translate/core';
import { ColumnSelectComponent } from '../column-select/column-select.component';

@Component({
  selector: 'app-flight-ticket-report',
  templateUrl: './flight-ticket-report.component.html',
  styleUrls: ['./flight-ticket-report.component.css']
})
export class FlightTicketReportComponent implements OnInit {

  public menu_item_id = '121';

  private dp = [];
  displayedColumns = ['sr', 'record_locator', 'title', 'customer_name_en', 'customer_last_name', 'member_id',
    'type', 'country_name_en', 'gender', 'date_of_birth', 'document_type', 'passport_no',
    'passport_expiry_date', 'doc_issue_con_code', 'birth_con_code', 'trip_depart_date', 
    'trip_arrival_date', 'print'];

  displayedColumns2 = ['sr', 'record_locator', 'title', 'customer_name_en', 'customer_last_name', 'member_id',
    'type', 'country_name_en', 'gender', 'date_of_birth', 'document_type', 'passport_no',
    'passport_expiry_date', 'doc_issue_con_code', 'birth_con_code', 'trip_depart_date', 'trip_arrival_date'];

  model = {
    'title': 'تقرير حجوزات الطيران', 'depart_date': new Date(), 'from_airport': '0', 'to_airport': '0'
  };

  today = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
  
  search_airport = {
    'placeholder': 'اسم المطار', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': 'airport', 'selected_no': 'airport_id',
      'field_list': ['airport_name', 'airport_name_en', 'airport_code']
    }]
  };

  dialog_data = [{ 'id': 'sr', 'title_ar': 'Number', 'title_en': 'Number', 'checked': '1' },
    { 'id': 'record_locator', 'title_ar': 'Record Locator', 'title_en': 'Record Locator', 'checked': '1' },
    { 'id': 'title', 'title_ar': 'Title', 'title_en': 'Title', 'checked': '1' },
    { 'id': 'customer_name_en', 'title_ar': 'First Name', 'title_en': 'First Name', 'checked': '1' },
    { 'id': 'customer_last_name', 'title_ar': 'Last Name', 'title_en': 'Last Name', 'checked': '1' },
    { 'id': 'member_id', 'title_ar': 'Passenger Number', 'title_en': 'Passenger Number', 'checked': '1' },
    { 'id': 'type', 'title_ar': 'Passenger Type', 'title_en': 'Passenger Type', 'checked': '1' },
    { 'id': 'country_name_en', 'title_ar': 'Nationality', 'title_en': 'Nationality', 'checked': '1' },
    { 'id': 'gender', 'title_ar': 'Gender', 'title_en': 'Gender', 'checked': '1' },
    { 'id': 'date_of_birth', 'title_ar': 'Date of Birth', 'title_en': 'Date of Birth', 'checked': '1' },
    { 'id': 'document_type', 'title_ar': 'Document Type', 'title_en': 'Document Type', 'checked': '1' },
    { 'id': 'passport_no', 'title_ar': 'Document Number', 'title_en': 'Document Number', 'checked': '1' },
    { 'id': 'passport_expiry_date', 'title_ar': 'Document Expiration', 'title_en': 'Document Expiration', 'checked': '1' },
    { 'id': 'doc_issue_con_code', 'title_ar': 'Country Code', 'title_en': 'Country Code', 'checked': '1' },
    { 'id': 'birth_con_code', 'title_ar': 'Birth Country Code', 'title_en': 'Birth Country Code', 'checked': '1' },
    { 'id': 'trip_depart_date', 'title_ar': 'Departure Date', 'title_en': 'Departure Date', 'checked': '1' },
    { 'id': 'trip_arrival_date', 'title_ar': 'Return Date', 'title_en': 'Return Date', 'checked': '1' }
  ];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  colDialogRef: MatDialogRef<ColumnSelectComponent>;

  depart_date = '';

  Reservations_Report; Search_Msg; Airport_Name;
  Departure_Date; From_Airport; To_Airport;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Reservations_Report').subscribe((res: string) => {
      this.Reservations_Report = res;
    });
    this.model['title'] = this.Reservations_Report;

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });

    translate.get('Airport_Name').subscribe((res: string) => {
      this.Airport_Name = res;
    });
    this.search_airport['placeholder'] = this.Airport_Name;
    
    translate.get('Departure_Date').subscribe((res: string) => {
      this.Departure_Date = res;
    });

    translate.get('From_Airport').subscribe((res: string) => {
      this.From_Airport = res;
    });

    translate.get('To_Airport').subscribe((res: string) => {
      this.To_Airport = res;
    });
  }

  ngOnInit() {
  }

  onChangeFromAirport = function (search_result: object) {
    this.model['from_airport'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeToAirport = function (search_result: object) {
    this.model['to_airport'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  search() {
    if (this.model['depart_date'] == undefined && this.model['from_airport'] == '0' && 
      this.model['to_airport'] == '0')
    {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getTicketRep', 'type_id': 'flight', 'from_airport': this.model['from_airport'], 
      'to_airport':this.model['to_airport'], 'order_return_date':'1' };

    if (this.model['depart_date'] != undefined) {
      this.depart_date = this.model['depart_date'].getFullYear() + "-" + (this.model['depart_date'].getMonth() + 1) + "-" +
        this.model['depart_date'].getDate();

      obj['depart_date'] = this.depart_date;
    }
      
    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
    .subscribe(data => {
      this.applicationConstants.appComp.hideBusyCursor();
      console.log(data);

      this.dp = data.data['list'];
      this.dataSource = new MatTableDataSource(this.dp);
      this.dataSource.sort = this.sort;
    });
  }

  column_select() {
    this.colDialogRef = this.dialog.open(ColumnSelectComponent, {
      hasBackdrop: false,
      data: this.dialog_data
    });
    this.colDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != undefined) {
          console.log(result);
          this.dialog_data = result;
          this.displayedColumns = [];
          this.dialog_data.forEach(element => {
            if (element.checked == '1')
              this.displayedColumns.push(element.id);
          });
        }
      });
  }

  printTicket(invoice_no, acct_number) {
    window.open(this.applicationConstants.ticketPrint + "?invoice_no=" + invoice_no + "&acct_number=" + 
      acct_number + "&lang=en&type=ticket", "_blank");
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Departure_Date + ": " + this.depart_date + '</td>';
    html_data += '<td width="33%"> ' + this.From_Airport + ": " + (document.getElementById('search_value_1') as HTMLInputElement).value + '</td>';
    html_data += '<td width="33%"> ' + this.To_Airport + ": " + (document.getElementById('search_value_2') as HTMLInputElement).value + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
